/**
 * Idempotency key for one-shot chat handoffs (pending-prompt auto-send).
 * `crypto.randomUUID` is unavailable in non-secure contexts (plain HTTP),
 * so fall back to a timestamped key namespaced by the caller.
 */
export function newIdempotencyKey(prefix: string): string {
  return globalThis.crypto?.randomUUID?.() ?? `${prefix}-${Date.now()}`
}
